import { render, staticRenderFns } from "./giftfinder.vue?vue&type=template&id=57a4c446&scoped=true"
import script from "./giftfinder.vue?vue&type=script&lang=js"
export * from "./giftfinder.vue?vue&type=script&lang=js"
import style0 from "./giftfinder.vue?vue&type=style&index=0&id=57a4c446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a4c446",
  null
  
)

export default component.exports